
<div class="index-image" v-if="index.image">
  <img
    class="fade"
    v-lazy="{ src: index.image, error: lightErrorImage }"
  />
</div>

<div v-else class="index-image">
  <icon :name="index.icon || 'account_circle'" />
</div>
